import createAxios from 'config/axios'

export const getFinancialPosition = () => { // eslint-disable-line
  return createAxios.get('/fortknox/v2/financialPosition')
}
